<template>
    <el-container class="mainXxcxBody">
        <el-col class="box">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="mainTitle">中介从业人员查询</span>
                    <span class="zsText">注：两个查询条件都必须精确输入</span>
                </div>
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-row>
                        <el-form-item label="姓名">
                            <el-input v-model="formInline.grqch" placeholder="输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="资质证号">
                            <el-input v-model="formInline.zzzh" placeholder="输入资质证号"></el-input>
                        </el-form-item>
                        <span class="cxzxClass3">
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                                <el-button @click="resetHt">重置</el-button>
                            </el-form-item>
                        </span>
                    </el-row>
                </el-form>
            </el-card>
            <div v-show="sfxs_ht">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="mainTitle">查询结果</span>
                    </div>
                    <div>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    姓名：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.GRQCH}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    证件类别：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.ZJLB}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    证件号码：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.ZJHM}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    所在单位：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.DWQCH}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    执业证号码：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.ZZZH}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    联系方式：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.LXDH}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    地址：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.LXDZ}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col >
                                <span class="qfhHcontent1">
                                    是否实名认证：
                                </span>
                                <span class="qfhHcontent2">
                                    {{zjcyrycxjg.SFSMRZ}}
                                </span>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
        </el-col>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        data() {
            return {
                formInline: {
                    grqch: '',
                    zzzh: ''
                },
                sfxs_ht:false,
                zjcyrycxjg:{},
                /*zjcyrycxjg: {
                    xm: '张三',
                    zjlb: '营业执照',
                    zjhm: '110292222227712',
                    szdw:'悠悠地产',
                    zzdj: '以及',
                    zzzh:'39832233',
                    lxfs:'029-29281982',
                    dz:'未来城平安区',
                    sfsmrz:'是',
                },*/
                reverse: true,
                value: ''
            }
        },
        methods: {
            ...mapActions([
                'HtxxSelect',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                if(this.formInline.grqch !=""||this.formInline.zzzh !=""){
                    this.HtxxSelect({_module:'TT',_method:'getGrxx',grqch:this.formInline.grqch,grlx: 'zjcy',zjhm:this.formInline.zzzh}).then((res) => {
                        if (res._result.GrxxList !=null ) {
                            /*业务信息list*/
                            this.zjcyrycxjg=res._result.GrxxList;
                            this.sfxs_ht=true;
                        }else{
                            this.warnMessage("没有查到信息，请检查个人名称与资质证号")
                        }
                    })
                }else{
                    this.warnMessage("个人名称与资质证号不能为空");
                }
            },
            resetHt(){
                this.formInline.grqch='';
                this.formInline.zzzh='';
                this.sfxs_ht=false;
            }
        }
    }
</script>
<style>
    @import "../../assets/css/xxcx/xxcx_main.css";
</style>

